module.exports = __webpack_public_path__ + "media/images/ppt-7718ba20.png";